import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import React from "react";
import { StyledButton } from "./styles";
import { EmployeeDTO } from "../../../../../models/employees";

interface Props {
  propertyLabel: string;
  property: keyof EmployeeDTO;
  propertyValue: string;
  updateSelectedItemProperty: (property: keyof EmployeeDTO, propertyKey?: keyof EmployeeDTO[keyof EmployeeDTO]) => void;
  isSelected: boolean;
  propertyKey?: keyof EmployeeDTO[keyof EmployeeDTO];
}

const SingleEmployeeProperty = ({
  propertyLabel,
  property,
  propertyValue,
  updateSelectedItemProperty,
  isSelected,
  propertyKey,
}: Props) => {
  const theme = useTheme();

  return (
    <>
      <TableRow>
        <TableCell>{propertyLabel} : </TableCell>
        {propertyValue ? (
          <TableCell align="left">
            {isSelected ? (
              <Badge
                style={{ color: theme.palette.success.main }}
                badgeContent={isSelected ? <FontAwesomeIcon icon={faCircleCheck} /> : <></>}
              >
                <StyledButton
                  onClick={() => updateSelectedItemProperty(property, propertyKey)}
                  variant="outlined"
                  color={"success"}
                >
                  <Typography>{propertyValue}</Typography>
                </StyledButton>
              </Badge>
            ) : (
              <StyledButton
                onClick={() => updateSelectedItemProperty(property, propertyKey)}
                variant="outlined"
                color={"primary"}
              >
                <Typography>{propertyValue}</Typography>
              </StyledButton>
            )}
          </TableCell>
        ) : (
          <TableCell></TableCell>
        )}
      </TableRow>
    </>
  );
};

export default SingleEmployeeProperty;
